import { ICamera, IUser } from '@api/models';
import { ICommentsActivity } from '@api/models/analytics.model';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { CommentStatusEnum, CommentTypeEnum, CommentStatusLabels, CommentTypeLabels } from '@api/enum';

interface CameraImageCommentListProps {
    isLoading: boolean;
    commentData: ICommentsActivity[];
}

const CameraImageCommentList = ({ isLoading, commentData }: CameraImageCommentListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={commentData}
            columns={[
                { header: 'ID' },
                { header: 'Image Name' },
                { header: 'Camera' },
                { header: 'Message' },
                { header: 'User' },
                { header: 'Type' },
                { header: 'Status' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{row._id}</Table.Cell>

                    <Table.Cell>{row.imageName}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.camera as ICamera).client}/projects/${
                                (row.camera as ICamera).project
                            }/cameras/${(row.camera as ICamera)._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.camera as ICamera)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>{row.message}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.user as IUser).client}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser)?.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Chip label={CommentTypeLabels[row.type]} color="primary" variant="outlined" />
                    </Table.Cell>

                    <Table.Cell>
                        <Chip
                            label={CommentStatusLabels[row.status]}
                            color={row.status === CommentStatusEnum.CLOSED ? 'success' : 'warning'}
                            variant="outlined"
                        />
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default CameraImageCommentList;
